import { translate } from '@repo/phrase';
import type { AssetType } from '@repo/types/asset';
import { Paragraph } from '@repo/ui/typography';

import { DialogModal } from '@/components/dialog-modal';

import { useAssetParams } from '@/hooks/asset.hooks';

import { useDeleteAssetMutation } from './asset-delete-modal.hooks';

interface Props {
    visible: boolean;
    onClose: () => void;
}

const getDialogModalTitle = (assetType: AssetType) => {
    if (assetType === 'draft') {
        return translate('dialog_delete_draft_order_title');
    }
    if (assetType === 'quote') {
        return translate('dialog_delete_quotation_order_title');
    }
    return '';
};

const getDialogModalBody = (assetId: string, assetType: AssetType) => {
    if (assetType === 'draft') {
        return translate('dialog_delete_draft_order_body', { number: assetId });
    }
    if (assetType === 'quote') {
        return translate('dialog_delete_quotation_order_body', { number: assetId });
    }
    return '';
};

export const AssetDeleteModal = ({ visible, onClose }: Props) => {
    const { assetId, assetType } = useAssetParams();
    const { mutate } = useDeleteAssetMutation();

    return (
        <DialogModal
            visible={visible}
            onClose={onClose}
            title={getDialogModalTitle(assetType)}
            primaryButtonProps={{
                text: translate('dialog_modal_footer_yes'),
                onClick: () => {
                    mutate(undefined, {
                        onSuccess: onClose,
                    });
                },
            }}
            secondaryButtonProps={{ text: translate('dialog_modal_footer_no'), onClick: onClose }}
        >
            <Paragraph>{getDialogModalBody(assetId, assetType)}</Paragraph>
        </DialogModal>
    );
};
